<button #button (click)="deactivate(button)" [class.darkMode]="isDarkMode$ | async" [type]="bottonType" [class]="className"   [class.gap-0]="!label" class="radius_xs btn" [style.width.px]="width" [disabled]="disabled" [attr.data-automation-id]="dataAutomationId"   [title]="!title ? '' : (title | translate)">
  @if (leftIcon) {
    <epmax-icon class="start_icon" [color]="!!rightIconColor? rightIconColor : iconColor " [size]="iconSize" [name]="leftIcon" [isOutlined]="isOutlinedStartIcon ? true : false"></epmax-icon>
  }
  <epmax-typo [color]="color" [name]="typoName" [weight]="typoWeight" [color]="typoColor">{{label | translate}}</epmax-typo>
  @if (rightIcon) {
    <epmax-icon [color]="iconColor" [size]="iconSize" [name]="rightIcon" [isOutlined]="isOutlinedStartIcon ? true : false"></epmax-icon>
  }
</button>
